import {
  BrandList,
  Main,
  Offer,
  Page,
  Section
} from '../../src/components/Layout';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { media, sizes } from '../../src/styles/media';

import Breadcrumb from '../../src/components/Breadcrumb';
import { Button } from '../../src/components/Button';
import { Container } from '../../src/components/Grid';
import Fade from 'react-reveal/Fade';
import Head from 'next/head';
import Header from '../../src/components/Header';
import ImageGallery from '../../src/components/ImageGallery/ImageGallery';
import { InfoBanner } from '../../src/components/Banner';
import { ParallaxTitle } from '../../src/components/Title';
import { Query } from 'react-apollo';
import { Simple } from '../../src/components/Layout/Media/Simple';
import { SmartMedia } from '../../src/components/Layout/Media';
import VideoGallery from '../../src/components/VideoGallery/VideoGallery';
import createContext from '../../src/utils/format/createContext';
import dynamic from 'next/dynamic';
import getMore from '../../src/utils/collection/getMore';
import getOffersByShop from '../../src/apollo/graphql/offer/getOffersByShop';
import getShop from '../../src/apollo/graphql/shop/getShop';
import getShopsByCategory from '../../src/apollo/graphql/shop/getShopsByCategory';
import routes from '../../conf/routes';
import styled from 'styled-components';
import { withI18N } from '../../src/hoc/index';
import Text from '../../src/components/Typography/Text';
import theme from '../../src/theme';
import useMobile from '../../src/utils/useMobile';

const OfferSlidesCarousel = dynamic(
  import('../../src/components/Carousel/OfferSlidesCarousel'),
  {
    // eslint-disable-next-line react/display-name
    loading: () => <div />,
    ssr: false
  }
);

const OfferSlider = ({ offers }) => {
  const { isMobile } = useMobile();

  return (
    <OfferSlidesCarousel
      slides={offers}
      isMobile={isMobile}
      centerSlides={false}
    />
  );
};

OfferSlider.propTypes = {
  offers: PropTypes.array
};

class Single extends PureComponent {
  static async getInitialProps({ query, i18n }) {
    return {
      slug: query && query.slug,
      i18n
    };
  }

  renderHeader = shop => {
    const { headerDesk, headerMob } = shop;
    return (
      <Header
        title={shop.name}
        subtitle={shop.category.detail.label}
        image={headerDesk || `/static/images/header-offers.jpg`}
        imageMobile={headerMob || `/static/images/header-offers.jpg`}
        noOverlay
      />
    );
  };

  renderBreadcrumb = shop => (
    <Container>
      <Breadcrumb
        items={[
          { href: '/', label: this.props.t('common:nav.tabs.home') },
          {
            href: `/${this.props.i18n.language}/${this.props.t(
              'common:brands.navigation.brands'
            )}/`,
            label: this.props.t('common:nav.menu.brands')
          },
          { label: shop.name }
        ]}
      />
    </Container>
  );

  renderImportant = shop => {
    if (shop.detail && shop.importantDesk && shop.detail.importantTexte) {
      return (
        <SmartMedia
          imageMobile={shop.importantMob}
          image={shop.importantDesk}
          content={shop.detail.importantTexte}
          link={shop.detail.importantCtaUrl}
          linkLabel={shop.detail.importantCtaLabel}
          reverse
          buttonCenter
          buttonInfo={false}
        />
      );
    }
    return null;
  };

  renderInformation = shop =>
    shop.detail && (
      <SmartMedia
        title={shop.detail.title}
        image={shop.imgDesk}
        logo={shop.logo1Desk}
        logoMobile={shop.logo1Mob}
        content={shop.detail.content}
        link={shop.detail.ctaUrl}
        linkLabel={shop.detail.ctaLabel}
        socials={shop.socialNetworks}
        buttonCenter={true}
      />
    );

  renderOpenings = shop => {
    return (
      shop.detail && (
        <Section noMarginBottom>
          <InfoBanner
            name={shop.name}
            type={shop.type}
            place={shop.place}
            hours={JSON.parse(shop.ttHours)}
            content={shop.detail.ttTexte}
            tel={shop.ttPhone}
            mail={shop.detail.ttCtaUrl}
            ctaLabel={shop.detail.ttCtaLabel}
          />
        </Section>
      )
    );
  };

  renderOffers = shop => {
    return (
      <Query
        query={getOffersByShop}
        variables={{ shopId: shop.id }}
        context={createContext(this.props.i18n.language)}
      >
        {({ loading, error, data }) => {
          if (!loading && !error && data && data.getOffersByShop) {
            const offers = data.getOffersByShop;
            return (
              offers.length > 0 && (
                <Section>
                  <Container>
                    <Fade up>
                      <Text
                        as="h3"
                        variant="heading2"
                        color={theme.color.brand.primary}
                        marginBottom="20px"
                      >
                        {this.props.t('common:brands.offers')}
                      </Text>
                    </Fade>
                    <Fade up>
                      <OfferSlider offers={offers} />
                    </Fade>
                    {/* <Wrapper>
                      <SliderComponentWithNoSSR
                        variableWidth={offers.length < 3}
                        autoplay={false}
                        autoplaySpeed={5000}
                        slidesToShow={3}
                        slidesToScroll={3}
                        infinite={true}
                        dots={true}
                        responsive={[
                          {
                            breakpoint: sizes.desktop - 1,
                            settings: {
                              slidesToShow: 2,
                              slidesToScroll: 2
                            }
                          },
                          {
                            breakpoint: sizes.tablet - 1,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                            }
                          }
                        ]}
                      >
                        {offers.map(
                          offer =>
                            offer.shop &&
                            offer.detail && (
                              <Offer
                                key={offer.id}
                                title={offer.detail.title}
                                link={`${this.props.t(
                                  'common:brands.navigation.brands'
                                )}/${offer.shop.slug}`}
                                linkLabel="Voir la boutique"
                                img={offer.image}
                                logo={offer.shop.logo2Desk}
                                date={offer.detail.offer_date}
                                text={offer.detail.description}
                                hideButton
                              />
                            )
                        )}
                      </SliderComponentWithNoSSR>
                      <Button
                        href={`${
                          routes.offers.langs[this.props.i18n.language]
                        }/`}
                      >
                        {this.props.t('common:home.offers.button')}
                      </Button>
                    </Wrapper> */}
                  </Container>
                </Section>
              )
            );
          }

          return null;
        }}
      </Query>
    );
  };

  renderMore = shop => (
    <Query
      query={getShopsByCategory}
      variables={{ categoryId: shop.category.id }}
      context={createContext(this.props.i18n.language)}
    >
      {({ loading, error, data }) => {
        if (!loading && !error && data && data.getShopsByCategory) {
          const sameShops = getMore(data.getShopsByCategory, shop);
          return (
            sameShops.length > 0 && (
              <Section>
                <Container>
                  <Fade up>
                    <Text
                      as="h3"
                      variant="heading2"
                      color={theme.color.brand.primary}
                      marginBottom="20px"
                    >
                      {this.props.t('common:brands.suggestions')}
                    </Text>
                  </Fade>
                  <Fade up>
                    <BrandList items={sameShops} />
                  </Fade>
                  <Fade up>
                    <Button
                      info
                      center
                      href={`${this.props.t(
                        'common:brands.navigation.brands'
                      )}/`}
                    >
                      {this.props.t('common:brands.cta.boutiques')}
                    </Button>
                  </Fade>
                </Container>
              </Section>
            )
          );
        }

        return null;
      }}
    </Query>
  );

  renderBlock(block, key) {
    if (block?.slides?.length < 1) return null;

    switch (block?.type) {
      case 'video_gallery_block':
        return (
          <Container key={key}>
            <VideoGallery data={block} />
          </Container>
        );
      case 'image_gallery_block':
        return (
          <Container key={key}>
            <ImageGallery data={block} />
          </Container>
        );
      default:
        return null;
    }
  }

  renderPage = shop => {
    const blockVideo = shop?.blocks?.find(
      block => block.type === 'video_gallery_block'
    );
    const blockImage = shop?.blocks?.find(
      block => block.type === 'image_gallery_block'
    );

    return (
      <div>
        <Head>
          <title>{shop.name}</title>
          <meta
            name="description"
            content={shop.detail && shop.detail.meta_og_description}
            key="description"
          />
          <meta
            property="og:title"
            content={shop.detail && shop.detail.meta_og_title}
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content={shop.detail && shop.detail.meta_og_url}
          />
          <meta
            property="og:description"
            content={shop.detail && shop.detail.meta_og_description}
          />
        </Head>
        {this.renderHeader(shop)}
        <Main>
          {this.renderBreadcrumb(shop)}
          {this.renderImportant(shop)}
          {this.renderInformation(shop)}
          {blockVideo && this.renderBlock(blockVideo, 'block_video')}
          {blockImage && this.renderBlock(blockImage, 'block_image')}
          {this.renderOpenings(shop)}
          {this.renderOffers(shop)}
          {this.renderMore(shop)}
        </Main>
      </div>
    );
  };

  render() {
    const { slug, i18n } = this.props;
    return (
      <Page brands>
        <Query
          query={getShop}
          variables={{ slug }}
          context={createContext(i18n.language)}
        >
          {({ loading, error, data }) => {
            if (!loading && !error && data && data.getShop) {
              const shop = data.getShop;
              return this.renderPage(shop);
            }

            return null;
          }}
        </Query>
      </Page>
    );
  }
}

export default withI18N()(Single);
